module.exports = __webpack_public_path__ + "img/shl@2x.250249b6.png";